import * as React from "react";

import Debug from "@/react/debug";

const useDynamicFilters = (table, filters) => {
  return React.useCallback(
    (params) => {
      Debug.log(
        "[useDynamicFilters] [applyFilter] called with params.",
        params
      );

      const addPresetFilter = filters?.addPresetFilter;
      const columnId = params?.columnId;
      const column = table?.getColumn(columnId);
      if (!column) {
        // We're issuing a warning here instead of an error just in case some runs of
        // this function are triggered accidentally when the table object is still not
        // fully initialized.
        Debug.warn(
          `Could not find column '${columnId}' required by applyFilter. Skipping silently.`
        );
        return;
      }

      addPresetFilter(
        column,
        params?.filterFnId,
        params?.filterValue,
        params?.replace
      );
    },
    [table, filters]
  );
};

export default useDynamicFilters;
